module.exports = __webpack_public_path__ + "img/ar-lqtajwid-2.a269f301.webp";